module.exports = __webpack_public_path__ + "img/hubl.in.png";